module.exports = __webpack_public_path__ + "img/doctor.f7519551.svg";